import axios from "axios";
import {BASE_API_URL, paramHeaders, paramHeadersPatch} from "../../app/AppConfig";
import {LoginData, UserAddresses, UserData} from "../Entity/User";
import {ResetPassword} from "../User/ChangePassword/AskNewPasswordTypes";
import {LocalParams} from "../../components/LocalParams";
import {GetCurrentLocale} from "../../components/Utils";
import {CreateAccount} from "../User/Account/CreateAccountTypes";
import {ContactFormData} from "../Contact/ContactFormType";
import {FavouriteProducts} from "../Entity/Product";

export async function postUserLogin(userName: string, password: string): Promise<{ token: string, customer: UserData }> {
  try {
    const response = await axios.post(
      `${BASE_API_URL}/authentication-token`,
      { email: userName, password },
      { headers: paramHeaders }
    );

    const token = response.data.token;
    let customer = response.data.customer;

    if (typeof customer === 'string') {
      const parts = customer.split('/');
      const id = parts[parts.length - 1];
      const fullCustomer = await axios.get<UserData>(
        `${BASE_API_URL}/customers/${id}`,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      customer = fullCustomer.data;
    }

    return { token, customer };
  } catch (err: any) {
    throw {
      code: err.response?.data?.code || 500,
      message: err.response?.data?.message || 'Erreur de connexion'
    };
  }
}





export async function resetPasswordRequest(email: string): Promise<null> {
  try {
    const response = await axios.post<null>(
      `${BASE_API_URL}/reset-password-requests`,
      {email: email}
    )
    return response.data
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message}
  }
}

export async function setNewPasswordRequest(passwords: ResetPassword, token: string): Promise<null> {
  try {
    const response = await axios.patch<null>(
      `${BASE_API_URL}/reset-password-requests/${token}`,
      {
          newPassword: passwords.password,
          confirmNewPassword: passwords.passwordConfirm
      },
{
          headers: paramHeadersPatch
      }
    )
    return response.data
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message}
  }
}

export async function getUserAccountRep(
  includeFavouriteProducts: boolean = true,
  includeAssociatedProduct: boolean = true
): Promise<UserData | undefined> {
  try {
    const customerJson = localStorage.getItem('customer');

    if (!customerJson) {
      throw new Error('Customer not found in localStorage');
    }

    const customer = JSON.parse(customerJson);
    const customerApiId = customer['@id'];
    const split = customerApiId.split('/');
    const userId = split[split.length - 1];

    const token = LocalParams.getItem('token');
    if (userId && token) {
      let response = await axios.get<UserData>(
        `${BASE_API_URL}/customers/${userId}`,
        { headers: { Authorization: 'Bearer ' + token } }
      );

      if (includeFavouriteProducts) {
        try {
          const favouriteProducts = await axios.get<FavouriteProducts[]>(
            `${BASE_API_URL}/favourite-products?locale=${GetCurrentLocale()}`,
            { headers: { Authorization: 'Bearer ' + token } }
          );
          response.data.favouriteProducts = favouriteProducts.data;
        } catch (err) {
          console.error('Erreur lors du chargement des produits favoris :', err);
        }
      }

      // if (includeAssociatedProduct) {
      //   const associatedProduct = await axios.get<AssociatedProduct[]>(
      //     `${BASE_API_URL}/suggested-products?locale=${GetCurrentLocale()}`,
      //     { headers: { Authorization: 'Bearer ' + token } }
      //   );
      //   response.data.suggestedProducts = associatedProduct.data;
      // }

      return response.data;
    } else {
      return undefined;
    }
  } catch (err) {
    throw new Error("Une erreur s'est produite");
  }
}


export async function updatePersonRep(formValues: CreateAccount): Promise<UserData> {
  try {
    const customerJson = localStorage.getItem('customer');

    if (!customerJson) {
      throw new Error('Customer not found in localStorage');
    }

    const customer = JSON.parse(customerJson);

    const customerApiId = customer['@id'];
    const split = customerApiId.split('/');
    const userId = split[split.length - 1];

    const token = LocalParams.getItem('token');
    const response = await axios.put<UserData>(
      `${BASE_API_URL}/customers/${userId}`,
      formValues,
      {headers: {Authorization: 'Bearer ' + token}}
    );
    return response.data;
  } catch (err) {
    throw new Error("erreur");
  }
}
export async function getUserAddressRep(): Promise<UserAddresses[]> {
  const token = LocalParams.getItem('token');
  if (token === null) {
    throw {code: 500, message: "User not authenticated" }
  }

  try {
    const response = await axios.get<UserAddresses[]>(
      `${BASE_API_URL}/addresses`,
      {headers: {Authorization: 'Bearer ' + token}}
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}


export async function updateUserAddressRep(adressId: any, newAddress: Partial<UserAddresses>): Promise<UserAddresses[]> {
  const token = LocalParams.getItem('token');
  if (token === null) {
    throw {code: 500, message: "User not authenticated" }
  }

  try {
    const response = await axios.put<UserAddresses[]>(
      `${BASE_API_URL}/addresses/${adressId}`,
      {
        "street" : newAddress.street,
        "postcode" : newAddress.postcode,
        "city" : newAddress.city,
        "countryCode" : newAddress.countryCode,
      },
      {headers: {Authorization: 'Bearer ' + token}}
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function subscrireToNewsletterRep(firstName: string, email: string): Promise<null> {
  try {
    const language = GetCurrentLocale();

    const response = await axios.post<null>(
      `${BASE_API_URL}/subscribe-to-newsletter`,
      {firstName: firstName, email: email, language: language}
    )
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}
export async function sendContactFormToBo(formValues: ContactFormData, userToken: string|null): Promise<boolean> {
  try {
    const response = await axios.post<any>(
      `${BASE_API_URL}/send-contact-form`,
      formValues,
      {
        headers: userToken ? {...paramHeaders, Authorization: 'Bearer ' + userToken} : paramHeaders
      }
    );
    return response.data;
  }
  catch (err:any) {
    if(err.response.data.code == "401")
    {
      return await sendContactFormToBo(formValues, null);
    }
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}


export async function getUserCatalogRep(token: string) {
  try {
    const response = await axios.get<any[]>(
      `${BASE_API_URL}/user-catalogs/me`,
      {
        headers: token ? {...paramHeaders, Authorization: 'Bearer ' + token} : paramHeaders
      }
    );
    return response.data;
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function addUserAddressRep(newAddress: Partial<UserAddresses>): Promise<UserAddresses> {
  const token = LocalParams.getItem('token');
  if (!token) throw { code: 401, message: "User not authenticated" };

  try {
    const response = await axios.post<UserAddresses>(
      `${BASE_API_URL}/me/addresses`,
      {
        street: newAddress.street,
        postcode: newAddress.postcode,
        city: newAddress.city,
        countryCode: newAddress.countryCode,
      },
      { headers: { Authorization: 'Bearer ' + token } }
    );
    return response.data;
  } catch (err: any) {
    throw { code: err.response?.status || 500, message: err.response?.data?.message || 'Erreur' };
  }
}
export async function deleteUserAddressRep(id: number): Promise<void> {
  const token = LocalParams.getItem('token');
  if (!token) throw { code: 401, message: "User not authenticated" };

  try {
    await axios.delete(`${BASE_API_URL}/addresses/${id}`, {
      headers: { Authorization: 'Bearer ' + token }
    });
  } catch (err: any) {
    throw { code: err.response?.status || 500, message: err.response?.data?.message || 'Erreur' };
  }
}
export async function postCustomerRegister(formValues: CreateAccount): Promise<boolean> {
  try {
    const response = await axios.post<LoginData>(
      `${BASE_API_URL}/customers`,
      formValues,
      {
        headers: paramHeaders
      }
    );
    return true;
  }
  catch (err) {
    throw { err }
  }
}

export async function addItemInWishListRep(productId: string): Promise<boolean> {
  const token = LocalParams.getItem('token');
  try {
    const response = await axios.put(
      `${BASE_API_URL}/toggle-favourite-product/${productId}`,
      {'productId': productId},
      {headers: {Authorization: 'Bearer ' + token}}
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

// export async function getSuggestedProductsRep(locale: string): Promise<AssociatedProduct> {
//   try {
//     const token = LocalParams.getItem('token');
//     const response = await axios.get<AssociatedProduct[]>(
//       `${BASE_API_URL}/suggested-products?locale=${locale}`,
//       {headers: {Authorization: 'Bearer ' + token}}
//     );
//     console.log(response.data)
//     return response.data;
//   }
//   catch (err:any) {
//     throw {code: err.response.data.code, message: err.response.data.message }
//   }
// }
